export default "__VITE_ASSET__JdXpCDv9__"